import Vue from "vue"

import { library } from "@fortawesome/fontawesome-svg-core"
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"
import { faBars, faEdit, faEllipsisH, faEllipsisV, faMobile, faQuestionCircle } from "@fortawesome/pro-light-svg-icons"

library.add(faEdit, faBars, faEllipsisV, faQuestionCircle, faEllipsisH, faMobile)

Vue.component("FontAwesomeIcon", FontAwesomeIcon)
